import { render, staticRenderFns } from "./Reservasi.vue?vue&type=template&id=719af9cb&"
import script from "./Reservasi.vue?vue&type=script&lang=js&"
export * from "./Reservasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports